import {
    FormControl,
    InputLabel,
    makeStyles,
    Select as MUISelect
} from "@material-ui/core";
import clsx from "clsx";
import PropTypes from "prop-types";
import React from "react";
import { validAscents } from "../../../constants/propTypesValidation";
import { styledBy } from "../../../utils/styles";
import DropdownItem from "../Dropdown/DropdownItem";

const useStyles = makeStyles((theme) => ({
    input: {
        marginBottom: theme.spacing(1),
        "&:after": {
            borderBottomColor: styledBy("ascent", theme.palette.ascents),
        },
        "& .Mui-required .MuiFormLabel-asterisk": {
            color: theme.palette.ascents.orange,
        },
        "& .MuiSelect-select.MuiSelect-select": {
            color: theme.palette.ascents.white,
        },
        "& .MuiSelect-icon": {
            color: theme.palette.ascents.white,
        },
        "&:before": {
            borderBottom: `2px solid ${theme.palette.ascents.primary} !important`,
        },
        "&:after": {
            borderBottomColor: styledBy("ascent", theme.palette.ascents),
            borderBottom: "none",
            background: `linear-gradient(45deg, ${theme.palette.ascents.primary} 20%, ${theme.palette.ascents.orange}) 80%`,
            height: "2px",
        },
        "&.MuiInputLabel-asterisk": {
            color: theme.palette.ascents.orange,
        },
        "&:hover": {
            "&:before": {
                borderBottom: `2px solid ${theme.palette.ascents.textDark} !important`,
            },
        }
    },

    label: {
        color: styledBy("ascent", theme.palette.ascents),
        "&.MuiInputLabel-shrink": {
            color: styledBy("ascent", theme.palette.ascents),
        },
        fontSize: '0.875rem',
    },

}));

const Select = ({
    ascent = "primary",
    required,
    className,
    parentClassName,
    labelId = `select-${Date.now()}`,
    id = `select-input-${Date.now()}`,
    value = '',
    onChange = () => { },
    fullWidth = true,
    startIcon,
    label,
    readOnly = false,
    options = [],
    ...props
}) => {
    const classes = useStyles({ ascent });

    const Options = (each, i) => {
        return (
            <DropdownItem selected key={i} value={each.value}>
                {each.label}
            </DropdownItem>
        )
    }
    // sort options by ascending order
    options = options.sort((a, b) => a.label > b.label ? 1 : -1)

    return (
        <FormControl required={required} fullWidth={fullWidth} className={parentClassName}>
            <InputLabel className={clsx(classes.label, className)} id={labelId}>
                {props.multiple ? label + ' (multi-select)' : label}
            </InputLabel>
            <MUISelect
                labelId={labelId}
                startAdornment={startIcon}
                required={required}
                id={id}
                value={value}
                onChange={onChange}
                className={clsx(classes.input, className)}
                readOnly={readOnly}
                {...props}
            >
                {options.map(Options)}
            </MUISelect>
        </FormControl>
    );
};

Select.propTypes = {
    options: PropTypes.arrayOf(PropTypes.object),
    ascent: validAscents,
};

export default Select;

